import { defaultSchema } from '@atlaskit/adf-schema/schema-default';
import {
  AdditionalParseOptions,
  BitbucketTransformer,
} from '@atlaskit/editor-bitbucket-transformer';
import type { JSONDocNode } from '@atlaskit/editor-json-transformer';
import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import FeatureGates from '@atlaskit/feature-gate-js-client';

import { StatsigFeatureKeys } from 'src/features';

const jsonTransformer = new JSONTransformer();

const serializer = new BitbucketTransformer(defaultSchema, {
  disableBitbucketLinkStripping: true,
});

export const encode = (doc: JSONDocNode) =>
  serializer.encode(defaultSchema.nodeFromJSON(doc));

export const parse = (
  html: string,
  additionalOptions: AdditionalParseOptions
) =>
  jsonTransformer.encode(
    serializer.parse(html, {
      ...additionalOptions,
      shouldParseCaptions: FeatureGates.checkGate(
        StatsigFeatureKeys.editorCaptionsEnabled
      ),
    })
  );
